/**
 * De quanto em quanto tempo o app repergunta ao servidor se chegou aviso.
 *
 * **A atualização é por ping, por decisão de produto (2026-08-06)** — não por
 * realtime nem por push. Push exigiria service worker, e docs/07 §8 decidiu que
 * este app não tem SW; realtime abriria um socket permanente, que é justamente
 * o que não sobrevive à rede de uma cidade em desastre.
 *
 * ## Por que **três** minutos
 *
 * O número sai de dois limites que se apertam:
 *
 * - **Por cima**, o que a pessoa aguenta esperar. O aviso mais urgente do
 *   produto é "uma instituição assumiu o seu pedido" / "chamado de voluntários":
 *   informação que envelhece em minutos. Meia hora de atraso transformaria a
 *   notificação em registro histórico.
 * - **Por baixo**, o custo em rede e bateria. Cada ping é um `count` sem linha
 *   (`head: true`) — centenas de bytes —, mas numa rede degradada o que dói é a
 *   **frequência** de conexões, não o tamanho. A cada minuto seriam 60 idas por
 *   hora de app aberto para um evento que acontece algumas vezes por dia.
 *
 * Três minutos dão ~20 pings por hora de tela aberta e um atraso máximo que
 * ainda cabe no tempo de resposta de um resgate. É um número escolhido, não
 * medido: quando houver telemetria de uso real, ele se revisa aqui — e só aqui,
 * porque a lista e o badge leem a mesma constante.
 *
 * ⚠️ Vale junto do padrão do react-query `refetchIntervalInBackground: false`:
 * aba escondida não pinga. O telefone no bolso não gasta rede, e o retorno ao
 * app já dispara um `refetch` por foco.
 */
export const NOTIFICATIONS_POLL_INTERVAL_MS = 3 * 60 * 1000;
